import {
  GET_ACQUISITION_CHANNEL_LIST,
  GET_ACQUISITION_CHANNEL_LIST_SUCCESS,
  GET_ACQUISITION_CHANNEL_LIST_FAILURE,
  GET_ACQUISITION_CHANNEL_DATA,
  GET_ACQUISITION_CHANNEL_DATA_SUCCESS,
  GET_ACQUISITION_CHANNEL_DATA_FAILURE,
  CREATE_ACQUISITION_CHANNEL,
  CREATE_ACQUISITION_CHANNEL_SUCCESS,
  CREATE_ACQUISITION_CHANNEL_FAILURE,
  UPDATE_ACQUISITION_CHANNEL,
  UPDATE_ACQUISITION_CHANNEL_SUCCESS,
  UPDATE_ACQUISITION_CHANNEL_FAILURE,
  DELETE_ACQUISITION_CHANNEL,
  DELETE_ACQUISITION_CHANNEL_SUCCESS,
  DELETE_ACQUISITION_CHANNEL_FAILURE,
} from "./actionType";

//reducer
const initialState = {
  acquisitionChannelList: [],
  acquisitionChannelListLoading: false,
  acquisitionChannelData: [],
  acquisitionChannelDataLoading: false,
  createAcquisitionChannelLoading: false,
  createAcquisitionChannelSuccess: [],
  updateAcquisitionChannelLoading: false,
  updateAcquisitionChannelSuccess: [],
  deleteAcquisitionChannelLoading: false,
  deleteAcquisitionChannelSuccess: [],
};

const CustomerAcquisitionChannel = (state = initialState, action) => {
  switch (action.type) {
    case GET_ACQUISITION_CHANNEL_LIST:
      return {
        ...state,
        acquisitionChannelListLoading: true,
      };
    case GET_ACQUISITION_CHANNEL_LIST_SUCCESS:
      return {
        ...state,
        acquisitionChannelList: action.payload,
        acquisitionChannelListLoading: false,
      };
    case GET_ACQUISITION_CHANNEL_LIST_FAILURE:
      return {
        ...state,
        acquisitionChannelListLoading: false,
      };
    case GET_ACQUISITION_CHANNEL_DATA:
      return {
        ...state,
        acquisitionChannelDataLoading: true,
      };
    case GET_ACQUISITION_CHANNEL_DATA_SUCCESS:
      return {
        ...state,
        acquisitionChannelData: action.payload,
        acquisitionChannelDataLoading: false,
      };
    case GET_ACQUISITION_CHANNEL_DATA_FAILURE:
      return {
        ...state,
        acquisitionChannelDataLoading: false,
      };
    case CREATE_ACQUISITION_CHANNEL:
      return {
        ...state,
        createAcquisitionChannelLoading: true,
      };
    case CREATE_ACQUISITION_CHANNEL_SUCCESS:
      return {
        ...state,
        createAcquisitionChannelLoading: false,
        createAcquisitionChannelSuccess: action.payload,
      };
    case CREATE_ACQUISITION_CHANNEL_FAILURE:
      return {
        ...state,
        createAcquisitionChannelLoading: false,
      };
    case UPDATE_ACQUISITION_CHANNEL:
      return {
        ...state,
        updateAcquisitionChannelLoading: true,
      };
    case UPDATE_ACQUISITION_CHANNEL_SUCCESS:
      return {
        ...state,
        updateAcquisitionChannelLoading: false,
        updateAcquisitionChannelSuccess: action.payload,
      };
    case UPDATE_ACQUISITION_CHANNEL_FAILURE:
      return {
        ...state,
        updateAcquisitionChannelLoading: false,
      };
    case DELETE_ACQUISITION_CHANNEL:
      return {
        ...state,
        deleteAcquisitionChannelLoading: true,
      };
    case DELETE_ACQUISITION_CHANNEL_SUCCESS:
      return {
        ...state,
        deleteAcquisitionChannelLoading: false,
        deleteAcquisitionChannelSuccess: action.payload,
      };
    case DELETE_ACQUISITION_CHANNEL_FAILURE:
      return {
        ...state,
        deleteAcquisitionChannelLoading: false,
      };
    default:
      return state;
  }
};

export default CustomerAcquisitionChannel;
